import moment from "moment";
import { Source } from "../content/contentModels";

export interface InitialState {
    
}

export interface Widget {
    id: string,
    name: string,
    code: string,
    media?: [] | null,
    assets?: [] | null,
    parameter: object | null,
    category: number
}

export interface WidgetInput {
  url?: string,
  videoUrl?: string,
  sheetId? : string,
  location?: string,
  end_time?: string,

//   width?  : number,
//   height? : number
}

export interface FullAddress {  //using for getting the current location
  road      : string;
  suburb    : string;
  state     : string;
  postcode  : string;
  city      : string;
  country   : string;
}


export const getWidgetContentValue = (src: Source, prefix=" - ", showFirstChar = false) => {
    let str = "";
    let srcParamSrc = src.param_source;
    if (srcParamSrc[0].type === "widget"){
        src = {...src, type: "widget"}
    }
    // console.log("src in getWidgetContentValue:", src)
    // ------------------------------------------
    let type = "";

    if (src && src.type === "widget" && src.param_source && src.param_source.length >= 0){
        if (src.param_source[0].type === "widget" || src.param_source[0].title === "widget"){
            const paramValue: any = src.param_source[0].paramValue? src.param_source[0].paramValue[0] : null;
            type = src.param_source[0].title? src.param_source[0].title.trim() : (src.param_source[0].type? src.param_source[0].type.trim() : "")

            switch (type){                
                case "clock"        : str = moment().format("hh:mm A"); break;
                case "date"         : str = moment().format("DD-MM-YYYY"); break;
                case "time"         : str = moment().format("hh:mm A"); break;
                case "weather"          : str = paramValue.location; break;
                case "weather forecast" : str = paramValue.location; break;
                case "qr code"      : str = paramValue.url; break;
                case "count down"   : str = moment(`${paramValue.targetDate} ${paramValue.targetTime}`, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm"); break;
                case "youtube"      : str = paramValue.videoId; break;
                case "google sheet" : str = paramValue.sheetId; break;
                case "google sheet" : str = paramValue.sheetId; break;                
                
            }
        }
    }
    
    return (str && str.length >0) ? `${showFirstChar && type? type.substring(0,1):""}${prefix} ${str}` : "";
}



